<mat-chip-set
    #trigger="cdkOverlayOrigin"
    cdk-overlay-origin>
    <mat-chip
        *ngFor="let item of internalValue()"
        removable
        [disabled]="disabled()"
        (removed)="remove(item)">
        {{ getItemLabel(item) }}
        <button
            matChipRemove
            [attr.aria-label]="'remove ' + item"
            [disabled]="disabled()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-chip>
    <button
        mat-button
        class="st-check-list-button"
        [disabled]="disabled()"
        (click)="toggle()">
        <span>{{ label() }}</span>
        <mat-icon>add</mat-icon>
    </button>
</mat-chip-set>

<ng-template
    cdk-connected-overlay
    [cdkConnectedOverlayOpen]="panelOpen()"
    [cdkConnectedOverlayOrigin]="trigger"
    (overlayOutsideClick)="close()">
    <mat-tree
        #control
        class="st-tree-checklist-menu"
        [dataSource]="dataSource"
        [treeControl]="treeControl">
        <mat-tree-node
            *matTreeNodeDef="let node"
            class="st-tree-menu-item"
            matTreeNodePadding
            matTreeNodeToggle>
            <mat-checkbox
                class="st-tree-checklist-menu-item__checkbox"
                labelPosition="before"
                [checked]="checklistSelection.isSelected(node.id)"
                (change)="leafItemSelectionToggle(node)"
                >{{ node?.value }}</mat-checkbox
            >
        </mat-tree-node>
        <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            class="st-tree-checklist-menu-item"
            matTreeNodePadding>
            <button
                mat-icon-button
                matTreeNodeToggle>
                <mat-icon class="mat-icon-rtl-mirror"> {{ treeControl.isExpanded(node) ? 'arrow_drop_up' : 'arrow_drop_down' }} </mat-icon>
            </button>
            <mat-checkbox
                class="st-tree-checklist-menu-item__checkbox"
                labelPosition="before"
                [checked]="descendantsAllSelected(node)"
                [indeterminate]="descendantsPartiallySelected(node)"
                (change)="itemSelectionToggle(node)"
                >{{ node?.value }}</mat-checkbox
            >
        </mat-tree-node>
    </mat-tree>
</ng-template>
